import React, {Component} from "react";
import {Navigate} from "react-router-dom";
import LocalStorageService from "../services/localStorageService";
import RedirectionService from "../services/redirectionService";

interface LogoutPageProps {
    onLogout: () => void,
}

interface LogoutPageState {
    redirectTo: string,
}

class LogoutPage extends Component<LogoutPageProps, LogoutPageState> {
    constructor(props: LogoutPageProps) {
        super(props);
        this.state = {
            redirectTo: "",
        };
    }

    componentDidMount() {
        // Clear tokens from localStorage
        LocalStorageService.signOut();
        
        // Update app state
        this.props.onLogout();
        
        // Redirect to login
        this.setState({
            redirectTo: RedirectionService.redirectToLogin("/dashboard"),
        });
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} replace />;
        }
        
        // Show loading state briefly while redirecting
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                color: "var(--text-primary)",
            }}>
                Logging out...
            </div>
        );
    }
}

export default LogoutPage;

